import { Box, Text } from '@chakra-ui/react';
import { PARTIALLY_SUPPORTED_PLATFORMS, SOCIAL_PLATFORMS } from '~/constants';

import { useAdvancedFiltersStore } from '../../../store/useAdvancedFilterStore';
import { InstagramMetrics } from './InstagramMetrics';
import { TiktokMetrics } from './TiktokMetrics';
import { YoutubeMetrics } from './YoutubeMetrics';

export const PerformanceMetrics: React.FC = () => {
  const { activePlatform } = useAdvancedFiltersStore();

  const PLATFORM_METRIC_COMPONENT = {
    [SOCIAL_PLATFORMS.instagram]: InstagramMetrics,
    [SOCIAL_PLATFORMS.tiktok]: TiktokMetrics,
    [SOCIAL_PLATFORMS.youtube]: YoutubeMetrics,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: null,
  } as const;

  const Metrics = PLATFORM_METRIC_COMPONENT[activePlatform];

  return (
    <Box>
      <Text fontSize="lg" fontWeight="500" color="primary.600">
        Performance Metrics
      </Text>
      {Metrics && <Metrics />}
    </Box>
  );
};
